    import React,{useState,useEffect} from "react"
    import stylesheet from "./footer.module.css"
    import { Link } from "react-router-dom"
    import { getTheme } from "../../../actions/localtheme";
    import { connect } from "react-redux";


    const Footer = (props)=>{
        const [gamechange,setgamechange] = useState("")
        useEffect(() => {
            props.getTheme()
            setgamechange(props.ThemeReducer.theme)
        }, [gamechange]);



        return(
            <>
            <div style={{background:props.ThemeReducer.theme}} className={`container-fluid ${stylesheet.main_footer} px-5 pt-5 pb-0`}>
                    <div className="row">
                        <div className="col-lg-5">
                            <h5>SUBSCRIBE TO OUR</h5>
                            <div className="py-5">
                                <h6>newsletter</h6>
                                <input placeholder="Your Email Address*"></input>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <h5>SHOP</h5>
                            <div className="pt-4 d-flex flex-column">
                                <Link>Login</Link>
                                <Link>Faq</Link>
                                <Link>Shipping and payment</Link>
                                <Link>Contact</Link>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <h5>GET INSPIRED</h5>
                            <div className="pt-4  d-flex flex-column">
                                <Link>Flowers</Link>
                                <Link>Pre-Rolled</Link>
                                <Link>CBD Oil</Link>
                                <Link>Refill</Link>
                                <Link>Discovery</Link>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <h5>FOLLOW US ON</h5>
                            <div className="pt-4 d-flex">
                                <img src="https://img.icons8.com/material-outlined/30/FFFFFF/instagram-new--v1.png"/>
                                <div className="ml-1 mb-0">
                                <Link>Follow us on</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className={`row py-4 ${stylesheet.sec_footer}`}>
                        <div className="col-lg-6  d-flex align-items-center">
                            <div className="mr-2">
                                <Link>Privacy & Cookies</Link>
                            </div>
                            <div className="mr-2">
                                <Link>Terms & Conditions</Link>
                            </div>
                        </div>
                        <div className="col-lg-6 d-flex align-items-center justify-content-end">
                        <div className="mr-2">
                                <Link>© MA Switzerland Retail Sagl - CHE-247.174625</Link>
                            </div>
                        </div>
                    </div>
            </div> 
            </>
        )
    }

    const mapStateToProps = (state) => ({
        ThemeReducer: state.ThemeReducer,
    });

    const mapDispatchToProps = (dispatch) => ({
        getTheme: (theme) =>
            dispatch(getTheme(theme)),
    });
    export default connect(mapStateToProps, mapDispatchToProps)(Footer);